import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { TabloGroupConfig } from '@ui/tablo-generator/types';

@Directive({
    selector: 'img.photoOverlay',
    standalone: false
})
export class PhotoOverlayColorDirective implements OnInit, OnChanges {
  @Input() config: TabloGroupConfig | null = null;
  @Input() index: number = 0;
  @Input() row: number = 0;
  @Input() imageUrl: string | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.updateOverlay();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['config'] || changes['index'] || changes['row'] || changes['imageUrl']) {
      this.updateOverlay();
    }
  }

  private updateOverlay(): void {
    if (!this.config || !this.imageUrl) {
      return;
    }

    // Get the hasColorOverlay value based on odd/even configuration
    let hasColorOverlay = false;
    if (this.config.childConfigDifferenceRule === 'oddEven') {
      hasColorOverlay = this.index % 2 === 0
        ? !!this.config.childPhotoOverlayHasColorOverlayEven
        : !!this.config.childPhotoOverlayHasColorOverlayOdd;
    } else if (this.config.childConfigDifferenceRule === 'oddEvenRow') {
      hasColorOverlay = this.row % 2 === 0
        ? !!this.config.childPhotoOverlayHasColorOverlayEven
        : !!this.config.childPhotoOverlayHasColorOverlayOdd;
    } else {
      hasColorOverlay = !!this.config.childPhotoOverlayHasColorOverlay;
    }

    // Get the colorOverlay value based on odd/even configuration
    let colorOverlay = '';
    if (this.config.childConfigDifferenceRule === 'oddEven') {
      colorOverlay = this.index % 2 === 0
        ? this.config.childPhotoOverlayColorOverlayEven || ''
        : this.config.childPhotoOverlayColorOverlayOdd || '';
    } else if (this.config.childConfigDifferenceRule === 'oddEvenRow') {
      colorOverlay = this.row % 2 === 0
        ? this.config.childPhotoOverlayColorOverlayEven || ''
        : this.config.childPhotoOverlayColorOverlayOdd || '';
    } else {
      colorOverlay = this.config.childPhotoOverlayColorOverlay || '';
    }

    if (hasColorOverlay && colorOverlay) {
      this.renderer.addClass(this.el.nativeElement, 'hasColorOverlay');
      this.renderer.setStyle(this.el.nativeElement, '--overlay-color', colorOverlay);
      this.renderer.setStyle(this.el.nativeElement, '--overlay-image', `url(${this.imageUrl})`);
      this.renderer.setProperty(this.el.nativeElement, 'src', '');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'hasColorOverlay');
      this.renderer.removeStyle(this.el.nativeElement, '--overlay-color');
      this.renderer.removeStyle(this.el.nativeElement, '--overlay-image');
      this.renderer.setProperty(this.el.nativeElement, 'src', this.imageUrl);
    }
  }
}
